import IPayload from "../interfaces/IPayload";
import IRevisaoCotaUsina from "../interfaces/IRevisaoCotaUsina";
import { ToQueryString } from "../utils/utils";
import api from "./api";
import { resources } from "./resources";

class RevisaoCotaUsinaService {
    async getById(id: string) {
        return await api.get<IRevisaoCotaUsina>(`${resources.revisaoCotaUsina}/GetById/${id}`);
    }

    async create(data: any) {
        return await api.post<any>(`${resources.revisaoCotaUsina}/Create`, data);
    }

    async update(data: any) {
        return await api.put<any>(`${resources.revisaoCotaUsina}/Update`, data);
    }

    async delete(id: any) {
        return await api.delete<any>(`${resources.revisaoCotaUsina}/Delete/${id}`);
    }

    async approve(id: any) {
        return await api.put<any>(`${resources.revisaoCotaUsina}/Approve/${id}`);
    }

    async getWithFilter(filters: any) {
        return await api.get<IPayload>(`${resources.revisaoCotaUsina}/GetWithFilter/${ToQueryString(filters)}`);
    }

    async getInstalacoesByRevisaoCotaUsina(id: any) {
        return await api.get<any>(`${resources.revisaoCotaUsina}/GetInstalacoesByRevisaoCotaUsina/${id}`);
    }

    async transfer(data: any) {
        return await api.post<any>(`${resources.revisaoCotaUsina}/Transfer`, data);
    }
}

export default new RevisaoCotaUsinaService();
